import NestedForm from "@stimulus-components/rails-nested-form/dist/stimulus-rails-nested-form.umd.js"

export default class extends NestedForm {
  add (event) {
    super.add(event)

    const allTrainingSessionDays = this.element.querySelectorAll(".nested-form-wrapper")
    const currentTrainingSessionDayElement = allTrainingSessionDays[allTrainingSessionDays.length - 1]
    if (!currentTrainingSessionDayElement) return

    const dayOffset = allTrainingSessionDays.length - 1
    const positionInput = currentTrainingSessionDayElement.querySelector("input[name*='position']")
    if (positionInput) positionInput.value = allTrainingSessionDays.length

    this.applyIncrementalDates(currentTrainingSessionDayElement, dayOffset)
  }

  // Keep start/end on the same calendar day. Time-only edits leave the sibling alone.
  syncSameDayDates (event) {
    const changedInput = event.target._flatpickr?.input || event.target
    const isStart = changedInput.name?.includes("[start_date]")
    const isEnd = changedInput.name?.includes("[end_date]")
    if (!isStart && !isEnd) return

    const dayElement = changedInput.closest(".nested-form-wrapper")
    if (!dayElement) return

    const startInput = dayElement.querySelector("input[name*='[start_date]']")
    const endInput = dayElement.querySelector("input[name*='[end_date]']")
    const sibling = isStart ? endInput : startInput
    if (!startInput || !endInput || !sibling) return

    const sourceDate = this.flatpickrDate(changedInput)
    const siblingDate = this.flatpickrDate(sibling)
    if (!sourceDate || !siblingDate || this.sameCalendarDay(sourceDate, siblingDate)) return

    const next = new Date(siblingDate)
    next.setFullYear(sourceDate.getFullYear(), sourceDate.getMonth(), sourceDate.getDate())
    this.updateFlatpickrDate(sibling, next, false)
  }

  applyIncrementalDates (dayElement, dayOffset) {
    const startDate = this.defaultDateAt(dayOffset, 8)
    const endDate = this.defaultDateAt(dayOffset, 16)

    dayElement.querySelectorAll("input[data-controller~='flatpickr']").forEach((input) => {
      const date = input.name.includes("[start_date]") ? startDate : endDate
      this.updateFlatpickrDate(input, date)
    })
  }

  defaultDateAt (dayOffset, hour) {
    const date = new Date()
    date.setHours(0, 0, 0, 0)
    date.setDate(date.getDate() + dayOffset)
    date.setHours(hour, 0, 0, 0)
    return date
  }

  updateFlatpickrDate (input, date, triggerChange = true) {
    const rawConfig = input.dataset.flatpickrConfigValue
    if (rawConfig) {
      const config = JSON.parse(rawConfig)
      config.defaultDate = date.toISOString()
      input.dataset.flatpickrConfigValue = JSON.stringify(config)
    }

    input.value = this.formatForFlatpickr(date)

    // Flatpickr may already be connected (or connect on the next tick with the updated defaultDate).
    requestAnimationFrame(() => {
      input._flatpickr?.setDate(date, triggerChange)
    })
  }

  flatpickrDate (input) {
    const selected = input._flatpickr?.selectedDates?.[0]
    if (selected) return selected

    return this.parseFlatpickrValue(input.value)
  }

  parseFlatpickrValue (value) {
    const match = value?.match(/^(\d{4})-(\d{2})-(\d{2})(?:\s+(\d{2}):(\d{2}))?/)
    if (!match) return null

    return new Date(
      Number(match[1]),
      Number(match[2]) - 1,
      Number(match[3]),
      Number(match[4] || 0),
      Number(match[5] || 0)
    )
  }

  sameCalendarDay (left, right) {
    return left.getFullYear() === right.getFullYear() &&
      left.getMonth() === right.getMonth() &&
      left.getDate() === right.getDate()
  }

  formatForFlatpickr (date) {
    const year = date.getFullYear()
    const month = String(date.getMonth() + 1).padStart(2, "0")
    const day = String(date.getDate()).padStart(2, "0")
    const hours = String(date.getHours()).padStart(2, "0")
    const minutes = String(date.getMinutes()).padStart(2, "0")

    return `${year}-${month}-${day} ${hours}:${minutes}`
  }
}
